<template>
  <div class="inline">
    <div v-if="type === 'submit-form'">
      <button
        @click="$root.submitForm()"
        :class="`button button--tertiary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'login'">
      <button
        @click="$parent.login()"
        :class="`button button--tertiary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'register'">
      <button
        @click="$parent.register()"
        :class="`button button--tertiary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else-if="type === 'submit'">
      <button
        @click="$parent.submit()"
        :class="`button button--tertiary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </button>
    </div>
    <div v-else>
      <nuxt-link
        :to="localePath(path)"
        :class="`button button--tertiary ${extraClass}`"
        v-html="text"
      >
        {{ text }}
      </nuxt-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonTertiary',
  props: {
    type: {
      default: 'link',
      required: false,
      type: String
    },
    path: {
      default: '',
      required: false,
      type: String
    },
    text: {
      default: '',
      required: true,
      type: String
    },
    extraClass: {
      default: '',
      required: false,
      type: String
    }
  }
}
</script>
